<header class="page-head" *ngIf="user.api_enabled">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-cloud"></i></span>
    <div>
      <h1 class="page-head__title">API</h1>
      <p class="page-head__subtitle">Chave de acesso à API de Parceiros.</p>
    </div>
  </div>
</header>

<div *ngIf="user.api_enabled" class="sf-card">
  <div class="alert alert-danger">
    <i class="fa fa-exclamation-triangle"></i>
    <div style="flex:1">
      Este conteúdo é de uso exclusivo e confidencial. Pedimos que não seja compartilhado com terceiros.
    </div>
  </div>

  <div class="alert alert-warning" data-testid="api-wallet-notice">
    <i class="fa fa-wallet"></i>
    <div style="flex:1">
      O saldo consultado pela API é a carteira em R$ (contas migradas) ou os créditos do pacote (contas não migradas) — mesma regra do painel.
    </div>
  </div>

  <div class="token-row">
    <button type="button" class="sf-btn sf-btn--primary btn-generate" [appLoadingButton]="generating" (click)="generateToken()">
      <i class="fa fa-refresh"></i> Gerar Chave de API
    </button>
    <input
      id="token"
      class="form-control token-input"
      type="password"
      readonly
      [value]="token ?? null"
      (click)="token ? copyToken() : undefined"
    />
    <button type="button" class="sf-btn sf-btn--secondary sf-btn--icon" [disabled]="token == null" (click)="copyToken()" ngbTooltip="Copiar">
      <i class="fa fa-copy"></i>
    </button>
  </div>

  <div class="observations">
    <span *ngIf="generated_at" class="field-hint">Gerado em: {{ generated_at | date: "dd/MM/yyyy H:mm:ss" }}</span>
    <a class="sf-btn sf-btn--ghost sf-btn--sm" href="https://docs.smsfunnel.com.br/api/parceiros" target="_blank">
      <i class="fa fa-book"></i> Documentação
    </a>
  </div>
</div>
